import React, { useState, useEffect } from 'react'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
import CreateNewSite from './components/Forms/CreateNewSite'
import SiteActionModal from './components/SiteActionModal'
import EditSite from './components/Forms/EditSite'
import SiteViewModal from './components/SiteViewModal'
import SmConfirmModal from '../UI/SmConfirmModal'
import SiteItem from './components/SiteItem'
import ViewGeofencedSite from './components/ViewGeofencedSite'
import { useCreateSiteModal, useEditSiteModal } from './Shared/hooks'
import { api } from '../Controllers/api'
import { getSites } from './Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../UI/Store/actions'
import TableTopSection from 'UI/TableTopSection'
import { Select, DropdownMenuPosition } from '@duik/it'

const Sites = props => {
  const [siteList, setSiteList] = useState(props.sites.siteList)
  const { createNewSiteModal, handleCreateNewSiteModal } = useCreateSiteModal()
  const { editSiteModal, handleEditSiteModal } = useEditSiteModal()
  const [siteActionModal, setSiteActionModal] = useState(false)
  const [siteViewModal, setSiteViewModal] = useState(false)
  const [geofencedSiteViewModal, setGeofencedSiteViewModal] = useState(false)
  const [geofencedSiteEditable, setGeofencedSiteEditable] = useState(false)
  const [siteDeleteModal, setSiteDeleteModal] = useState(false)
  const [siteDeleteDetail, setSiteDeleteDetail] = useState()
  const [searchValue, setSearchValue] = useState('')
  const [searchedValue, setSearchedValue] = useState('')
  const [searchFilter, setSearchFilter] = useState(false)
  const [currentSite, setCurrentSite] = useState()
  const [activeFilter, setActiveFilter] = useState({ value: 'all', label: 'All' })

  const editSiteModalToggle = _id => {
    const site = siteList.find(site => site._id === _id)
    setCurrentSite(site)
    handleEditSiteModal()
    if (siteViewModal) {
      setSiteViewModal(false)
    }
  }

  const siteActionModalToggle = () => {
    setSiteActionModal(true)
    setTimeout(() => {
      setSiteActionModal(false)
    }, 2500)
  }

  const siteViewModalToggle = _id => {
    const site = siteList.find(site => site._id === _id)
    setCurrentSite(site)
    setSiteViewModal(!siteViewModal)
  }

  const geofencedSiteViewModalToggle = (_id, siteEditable) => {
    const site = siteList.find(site => site._id === _id)
    setGeofencedSiteEditable(siteEditable)
    setCurrentSite(site)
    setGeofencedSiteViewModal(!geofencedSiteViewModal)
  }

  const getSites = () => {
    props.getSites()
  }

  const deleteSite = () => {
    const { _id } = siteDeleteDetail
    if (_id) {
      props.setSnackBarCopy('delete')

      api.delete(`sites/${_id}`).then(data => {
        setSiteDeleteModal(!siteDeleteModal)
        siteActionModalToggle()
        getSites()
      })
    } else {
      setSiteDeleteModal(!siteDeleteModal)
    }
  }

  const siteDeleteModalToggle = _id => {
    const site = siteList.find(site => site._id === _id)
    setSiteDeleteDetail(site)
    setSiteDeleteModal(!siteDeleteModal)
  }

  const createSite = (
    siteName,
    company,
    coordinates,
    customCoordinates,
    radius,
    type,
    project,
    defaultInstructions
  ) => {
    props.setSnackBarCopy('create')
    if (coordinates.lat || customCoordinates.length > 0) {
      const body = {
        siteName,
        company,
        coordinates,
        radius,
        customCoordinates,
        type,
        project,
        defaultInstructions
      }
      api
        .post(`sites`, body)
        .then(data => {
          siteActionModalToggle()
          getSites()
        })
        .catch(err => {
          alert('Error creating site. Please try again.')
        })
    } else {
      const body = { siteName, company, radius }
      api
        .post(`sites`, body)
        .then(data => {
          siteActionModalToggle()
          getSites()
        })
        .catch(err => {
          alert('Error creating site. Please try again.')
        })
    }
  }

  const editSite = (
    _id,
    siteName,
    company,
    location,
    city,
    province,
    coordinates,
    customCoordinates,
    radius,
    type,
    project,
    defaultInstructions
  ) => {
    props.setSnackBarCopy('edit')
    const body = {
      siteName,
      company,
      location,
      city,
      province,
      coordinates,
      radius,
      customCoordinates,
      type,
      project,
      defaultInstructions
    }
    api.put(`sites/${_id}`, body).then(() => {
      siteActionModalToggle()
      getSites()
      handleEditSiteModal()
    })
  }

  const search = e => {
    e.preventDefault()
    setSearchedValue(searchValue)
    props.history.push(`/app/sites?search=${searchValue}`)
    let searchList = []
    if (searchValue.length === 0) {
      props.history.push(`/app/sites`)
      setSearchFilter(false)
      setSiteList(props.sites.siteList)
      return
    }

    props.sites.siteList.map(item => {
      if (
        item.siteName.toLowerCase().search(searchValue.toLowerCase()) !== -1 ||
        item.company.toLowerCase().search(searchValue.toLowerCase()) !== -1 ||
        item.city.toLowerCase().search(searchValue.toLowerCase()) !== -1
      ) {
        searchList = searchList.concat(item)
      }
    })
    setSiteList(searchList)
    setSearchFilter(true)
  }

  const clearSearch = () => {
    setSearchValue('')
    setSearchedValue('')
    props.history.push(`/app/sites`)
    setSiteList(props.sites.siteList)
    setSearchFilter(false)
  }

  const filterSites = filterType => {
    switch (filterType.value) {
      case 'all':
        setSiteList(props.sites.siteList)
        setActiveFilter(filterType)
        break
      case 'dump':
        const dumpList = props.sites.siteList.filter(site => site.type === 'Dump')
        setSiteList(dumpList)
        setActiveFilter(filterType)
        break
      case 'project':
        const projectList = props.sites.siteList.filter(site => site.type === 'Project')
        setSiteList(projectList)
        setActiveFilter(filterType)
        break
      case 'source':
        const sourceList = props.sites.siteList.filter(site => site.type === 'Source')
        setSiteList(sourceList)
        setActiveFilter(filterType)
        break
      case 'transfer':
        const transferList = props.sites.siteList.filter(site => site.type === 'Transfer')
        setSiteList(transferList)
        setActiveFilter(filterType)
        break
      default:
        break
    }
  }

  useEffect(() => {
    props.getSites(true)
  }, [])

  useEffect(() => {
    if (props.sites.siteList && searchValue === '' && searchedValue === '') {
      setSiteList(props.sites.siteList)
    }
  }, [props.sites.loading, props.sites.siteList, searchValue, searchedValue])

  return (
    <MainContainer>
      <TableContainer style={createNewSiteModal || editSiteModal ? { display: 'none' } : undefined}>
        <TableTopSection
          title="Sites"
          loading={props.sites.loading}
          searchString={
            !props.sites.loading ? (
              <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
                {!searchFilter &&
                  siteList &&
                  searchedValue.length === 0 &&
                  `${siteList.length} Sites`}
                {!siteList && `0 Sites`}
                {searchFilter &&
                  `${siteList.length} ${
                    siteList.length > 1 ? 'Sites' : 'Site'
                  } found for '${searchedValue}'`}
              </p>
            ) : (
              undefined
            )
          }
          searchSubmit={e => search(e)}
          searchXButtonPress={clearSearch}
          searchValue={searchValue}
          setSearchValue={v => setSearchValue(v)}
          handlePlusIconClick={handleCreateNewSiteModal}
          additionalElement={
            <Select
              className="filterSelectRight"
              activeOption={{
                value: activeFilter.value,
                label: (
                  <span className="haulViewTitle">
                    View:<span className="haulViewType">{activeFilter.label}</span>
                  </span>
                )
              }}
              options={[
                { value: 'all', label: 'All' },
                { value: 'dump', label: 'Dump' },
                { value: 'project', label: 'Project' },
                { value: 'source', label: 'Source' },
                { value: 'transfer', label: 'Transfer' }
              ]}
              onOptionClick={e => filterSites(e)}
              menuPosition={DropdownMenuPosition['bottom-right']}
              style={{ margin: '0 20px 0 15px' }}
            />
          }
        />
        <TableSection>
          <thead>
            <tr>
              {['', 'COMPANY', 'CITY', 'TYPE', ''].map((item, index) => (
                <TableHeader key={index} title={item} />
              ))}
            </tr>
          </thead>
          <tbody>
            {!props.sites.loading && props.sites.siteList && siteList ? (
              siteList.map((site, index) => (
                <SiteItem
                  key={site._id}
                  site={site}
                  editSiteModalToggle={editSiteModalToggle}
                  siteViewModalToggle={siteViewModalToggle}
                  geofencedSiteViewModalToggle={geofencedSiteViewModalToggle}
                  siteDeleteModalToggle={siteDeleteModalToggle}
                  index={index}
                  companyId={props.companyId}
                />
              ))
            ) : (
              <tr></tr>
            )}
          </tbody>
        </TableSection>
      </TableContainer>

      {createNewSiteModal && (
        <CreateNewSite
          createNewSiteModalToggle={handleCreateNewSiteModal}
          createSite={createSite}
          createNewSiteModal={createNewSiteModal}
          projectList={props.projectList}
        />
      )}
      {editSiteModal && (
        <EditSite
          editSiteModalToggle={editSiteModalToggle}
          editSite={editSite}
          editSiteDetail={currentSite}
          editSiteModal={editSiteModal}
          projectList={props.projectList}
        />
      )}
      {siteActionModal && <SiteActionModal siteAction={props.snackBarCopy} />}
      {siteViewModal && (
        <SiteViewModal
          siteViewModalToggle={siteViewModalToggle}
          siteViewDetail={currentSite}
          companyId={props.companyId}
          editSiteModalToggle={editSiteModalToggle}
        />
      )}
      {geofencedSiteViewModal && (
        <ViewGeofencedSite
          siteViewDetail={currentSite}
          siteViewModalToggle={siteViewModalToggle}
          geofencedSiteViewModalToggle={geofencedSiteViewModalToggle}
          editSite={editSite}
          siteIsEditable={geofencedSiteEditable}
          companyId={props.companyId}
        />
      )}
      {siteDeleteModal && (
        <SmConfirmModal
          heading="Delete Site"
          text={`Are you sure you want to delete site ${siteDeleteDetail.siteName}?`}
          onCloseClick={siteDeleteModalToggle}
          onOKClick={deleteSite}
        />
      )}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    sites: state.sites,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    companyId: state.user.userData.companyId,
    projectList: state.projects.projectList
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSites,
      setSnackBarCopy,
      toggleSnackBar
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Sites)
